module.exports = __webpack_public_path__ + "img/result_ls_desk_angle.fc60d7e5.jpg";